// LICENSE_CODE ZON
'use strict'; /*jslint react:true es6:true*/
import React from 'react';
import cn from 'classnames';
import {Text} from '@pub/comp/text';
import * as cns from './checkbox.module.less';

export function Checkbox({
    className,
    value,
    on_change,
    disabled,
    label,
    ...rest
})
{
    return <label className={cn(cns.root, className)}>
      <input type="checkbox" className={cns.input} checked={value}
        onChange={on_change} {...rest} disabled={disabled}/>
      <Text.s className={cns.label}>{label}</Text.s>
    </label>;
}
